export default "__VITE_ASSET__CI7LHJQB__"